var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Flex, Box } from '..';
var CustomBox = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 2px;\n"], ["\n  border-radius: 2px;\n"])));
var defaultStepColor = 'background.light';
var propTypes = {
    steps: PropTypes.arrayOf(PropTypes.shape({
        color: PropTypes.string,
    })).isRequired,
    currentStep: PropTypes.number.isRequired,
    stepHeight: PropTypes.string,
    className: PropTypes.string,
};
var ProgressBar = function (_a) {
    var steps = _a.steps, currentStep = _a.currentStep, stepHeight = _a.stepHeight, className = _a.className;
    return (React.createElement(Flex, { className: className }, steps.map(function (step, index) {
        var stepColor = index < currentStep ? steps[currentStep - 1].color : defaultStepColor;
        return (React.createElement(CustomBox, { key: index, color: stepColor, height: stepHeight, width: 1, mr: 1, "data-testid": 'test-id-' + index }));
    })));
};
ProgressBar.propTypes = propTypes;
ProgressBar.defaultProps = {
    stepHeight: '4px',
};
export default ProgressBar;
var templateObject_1;
//# sourceMappingURL=ProgressBar.js.map